export abstract class MenuMappingConstants {
    static MENU_DATA: any = [
        {
            routerLink: 'manage-profile',
            id: 'shell.header.manageProfile2',
            value: 'shell.header.manageProfile',
            isAuthentication: true,
        },
        {
            routerLink: 'my-cards',
            id: 'shell.header.myCards',
            value: 'shell.header.myCards',
            isAuthentication: true,
        },
        {
            routerLink: 'my-alerts',
            id: 'shell.header.myAlerts',
            value: 'shell.header.myAlerts',
            isAuthentication: true,
        },
        {
            routerLink: '/login/user',
            id: 'shell.header.signIn',
            value: 'shell.header.signIn',
            isAuthentication: false,
            pcnOnly: true, // Make sure tenuant return pcnOnly Value then only make it True
        },
        {
            routerLink: '/login/card',
            id: 'shell.header.activateCard',
            value: 'shell.header.activateCard',
            isAuthentication: false,
        },
        {
            routerLink: '/redeem',
            id: 'shell.header.redeemCode',
            value: 'shell.header.redeemCode',
            isAuthentication: false,
        },
        {
            routerLink: '/get-rl',
            id: 'shell.header.getRl',
            value: 'shell.header.getRl',
            isAuthentication: false,
        },
    ];
}
